// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { ProDeploymentApi } from '../types/pro-deployment.types';
import { proDeploymentHttpApi } from './pro-deployment.api';
import { proDeploymentMockApi } from './pro-deployment.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const proDeploymentApi: ProDeploymentApi = useMock
  ? proDeploymentMockApi
  : proDeploymentHttpApi;
